export const SCHEDULE_STANDBY = 9;

export const SCHEDULE_TEMP_MIN = 0;
export const SCHEDULE_TEMP_MAX = 3;

export function isTemperatureScheduleValue(value: number): boolean {
  return value >= SCHEDULE_TEMP_MIN && value <= SCHEDULE_TEMP_MAX;
}

export function scheduleTileHeatClass(scheduleValue: number): string {
  if (scheduleValue === SCHEDULE_STANDBY) return "heat-standby";
  if (isTemperatureScheduleValue(scheduleValue)) return `heat-${scheduleValue}`;
  return "heat-0";
}
